<template>
    <div id="content">
        <div class="container">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <forgot-password/>
                </div>
            </div>
        </div>
        <powered-by v-if="hasPoweredBy"/>
    </div>
</template>

<style lang="scss" scoped>
    #content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 130px 0 30px;
    }
</style>

<script>
  import ForgotPassword from '../components/ForgotPassword.vue';
  import PoweredBy from '../components/PoweredBy.vue';

  export default {
    components: {
      ForgotPassword,
      PoweredBy,
    },
  };
</script>
